<script lang="ts">
	import Container from '$lib/components/App/Container.svelte';
	import { page } from '$app/stores';

	const missing_languages = {
		en: {
			title: `We're sorry but Riva is only available in French for now.`,
			desc: `
				Dutch and English will be available soon.
                <a style='outline:unset;' href='https://1klfci2roqk.typeform.com/to/grb43F3W'>Sign up here</a> to stay updated or continue to book in French. Thank you for your understanding!`
		},
		nl: {
			title: `We're sorry but Riva is only available in French for now.`,
			desc: `Dutch and English will be available soon.
            <a style='outline:unset;' href='https://1klfci2roqk.typeform.com/to/grb43F3W'>Sign up here</a> to stay updated or continue to book in French. Thank you for your understanding!`
		}
	};

	const lang = $page.params.lang as keyof typeof missing_languages;

	const frenchUrl = $page.url.href.replace(`/${lang}`, '/fr');
</script>

<Container style="padding-bottom: var(--spacing-l);">
	<div class=" container">
		<h1>{@html missing_languages[lang].title}</h1>
		<h3>{@html missing_languages[lang].desc}</h3>

		<a
			href={frenchUrl}
			tabindex="0"
			onclick={() => {}}
			class="button secondary"
			style={`font-size: 1em`}
		>
			Continue in french
		</a>
	</div>
</Container>

<style>
	.container {
		display: flex;
		gap: var(--gap);
		flex-wrap: wrap;
		justify-content: flex-start;
		max-width: 1250px;
	}

	h1 {
		font-size: 2.5em;
	}

	h3 {
		margin: 0;
		font-weight: 400;
		line-height: 1.5em;
		text-wrap: balance;
	}
</style>
